import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Chatbot from "@/components/Chatbot";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Contestants from "@/pages/Contestants";
import Episodes from "@/pages/Episodes";
import BagoAI from "@/pages/BagoAI";
import Sponsors from "@/pages/Sponsors";
import News from "@/pages/News";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Apply from "@/pages/Apply";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/contestants" element={<Contestants />} />
              <Route path="/episodes" element={<Episodes />} />
              <Route path="/bago-ai" element={<BagoAI />} />
              <Route path="/governor-bago" element={<BagoAI />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/news" element={<News />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/apply" element={<Apply />} />
            </Routes>
          </Layout>
          <Chatbot />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
